import { Link } from 'react-router-dom';

interface CatalogBannerProps {
  title: string;
  subtitle?: string;
  breadcrumb?: { label: string; to?: string }[];
}

export function CatalogBanner({ title, subtitle, breadcrumb }: CatalogBannerProps) {
  return (
    <div className="border-b border-surface-200 bg-white">
      <div className="container-app py-4 lg:py-8">
        {breadcrumb && breadcrumb.length > 0 && (
          <nav className="mb-1.5 hidden font-mono text-[11px] text-surface-500 sm:block">
            <Link to="/" className="hover:text-brand-700">
              inicio
            </Link>
            {breadcrumb.map((b, i) => (
              <span key={i}>
                {' / '}
                {b.to ? (
                  <Link to={b.to} className="hover:text-brand-700">
                    {b.label.toLowerCase()}
                  </Link>
                ) : (
                  <span className="text-surface-700">{b.label.toLowerCase()}</span>
                )}
              </span>
            ))}
          </nav>
        )}
        <h1 className="font-display text-lg font-bold text-surface-950 sm:text-2xl">{title}</h1>
        {subtitle && (
          <p className="mt-1 max-w-2xl text-sm leading-relaxed text-surface-600 sm:mt-1.5">
            {subtitle}
          </p>
        )}
      </div>
    </div>
  );
}
